import {
  AwaitingStoreOrderProposal,
  Store,
  StoreOrder,
  StoreOrderId
} from "../../models/Store";
import { MinimalStoreInventoryItem } from "../../models/StoreInventory";
import { Tenant } from "../../models/Tenant";
import { StoreDistributor } from "../../models/StoreDistributor";

export const REQUEST_STORES = "REQUEST_STORES";
export const REQUEST_STORES_DONE = "REQUEST_STORES_DONE";

export const REQUEST_STORE_INVENTORY_ITEMS = "REQUEST_STORE_INVENTORY_ITEMS";
export const REQUEST_STORE_INVENTORY_ITEMS_DONE =
  "REQUEST_STORE_INVENTORY_ITEMS_DONE";
export const REQUEST_STORE_CLUSTER_INVENTORY_ITEMS =
  "REQUEST_STORE_CLUSTER_INVENTORY_ITEMS";
export const REQUEST_ALL_STORE_INVENTORY_ITEMS =
  "REQUEST_ALL_STORE_INVENTORY_ITEMS";
export const REQUEST_STORE_DISTRIBUTORS = "REQUEST_STORE_DISTRIBUTORS";
export const REQUEST_STORE_DISTRIBUTORS_DONE =
  "REQUEST_STORE_DISTRIBUTORS_DONE";
export const REQUEST_STORE_ORDERS = "REQUEST_STORE_ORDERS";
export const REQUEST_STORE_ORDERS_DONE = "REQUEST_STORE_ORDERS_DONE";
export const REMOVE_STORE_ORDERS = "REMOVE_STORE_ORDERS";
export const REQUEST_AWAITING_STORE_ORDER_PROPOSALS =
  "REQUEST_AWAITING_STORE_ORDER_PROPOSALS";

export const REQUEST_FILTERED_STORES = "REQUEST_FILTERED_STORES";
export const REQUEST_FILTERED_STORES_DONE = "REQUEST_FILTERED_STORES_DONE";
export const SAVE_FILTERED_STORES = "SAVE_FILTERED_STORES";
export const SAVE_FILTERED_STORES_DONE = "SAVE_FILTERED_STORES_DONE";

export interface FetchStores {
  type: typeof REQUEST_STORES;
  payload: ReadonlyArray<Store>;
}

export interface FetchStoresDone {
  type: typeof REQUEST_STORES_DONE;
  payload: ReadonlyArray<Store>;
}

export interface FetchStoreInventoryItems {
  type: typeof REQUEST_STORE_INVENTORY_ITEMS;
  storeId: string;
  payload: ReadonlyArray<MinimalStoreInventoryItem>;
}

export interface FetchStoreInventoryItemsDone {
  type: typeof REQUEST_STORE_INVENTORY_ITEMS_DONE;
  storeId: string;
  payload: ReadonlyArray<MinimalStoreInventoryItem>;
}

export interface FetchAllStoreInventoryItems {
  type: typeof REQUEST_ALL_STORE_INVENTORY_ITEMS;
  payload: ReadonlyArray<MinimalStoreInventoryItem>;
}

export interface FetchStoreDistributors {
  type: typeof REQUEST_STORE_DISTRIBUTORS;
  storeId: string;
  payload: ReadonlyArray<StoreDistributor>;
}

export interface FetchStoreDistributorsDone {
  type: typeof REQUEST_STORE_DISTRIBUTORS_DONE;
  storeId: string;
  payload: ReadonlyArray<StoreDistributor>;
}

export interface FetchStoreOrders {
  type: typeof REQUEST_STORE_ORDERS;
  storeId: string;
  payload: ReadonlyArray<StoreOrder>;
}

export interface FetchStoreOrdersDone {
  type: typeof REQUEST_STORE_ORDERS_DONE;
  storeId: string;
  payload: ReadonlyArray<StoreOrder>;
}

export interface RemoveStoreOrders {
  type: typeof REMOVE_STORE_ORDERS;
  storeId: string;
  payload: ReadonlyArray<StoreOrderId>;
}

export interface FetchAwaitingStoreOrderProposals {
  type: typeof REQUEST_AWAITING_STORE_ORDER_PROPOSALS;
  payload: ReadonlyArray<AwaitingStoreOrderProposal>;
}

export interface StoresState {
  isLoading: boolean;
  stores: ReadonlyArray<Store>;
}

export interface StoreInventoryItemsState {
  isLoading: boolean;
  storeInventoryItems: ReadonlyArray<MinimalStoreInventoryItem>;
}

export interface AllInventoryItemsState {
  isLoading: boolean;
  storeInventoryItems: ReadonlyArray<MinimalStoreInventoryItem>;
}

export interface StoreDistributorsState {
  isLoading: boolean;
  storeDistributors: ReadonlyArray<StoreDistributor>;
}

export interface AwaitingStoreOrderProposalsState {
  awaitingStoreOrderProposals: ReadonlyArray<AwaitingStoreOrderProposal>;
}

export interface StoreOrdersState {
  isLoading: true;
  orders: ReadonlyArray<StoreOrder>;
}

/* Filtering stores */
export interface FilteredStoresState {
  isLoading: true;
  stores: ReadonlyArray<Store>;
}

export interface FetchFilteredStores {
  type: typeof REQUEST_FILTERED_STORES;
  payload: ReadonlyArray<Store>;
}

export interface FetchFilteredStoresDone {
  type: typeof REQUEST_FILTERED_STORES_DONE;
  payload: ReadonlyArray<Store>;
}

export interface SaveFilteredStores {
  type: typeof SAVE_FILTERED_STORES;
  payload: Store[];
}

export interface SaveFilteredStoresDone {
  type: typeof SAVE_FILTERED_STORES_DONE;
  payload: Store[];
}

export type StoreActionTypes =
  | FetchStores
  | FetchStoresDone
  | FetchStoreInventoryItems
  | FetchStoreInventoryItemsDone
  | FetchAllStoreInventoryItems
  | FetchStoreDistributors
  | FetchStoreDistributorsDone
  | FetchStoreOrders
  | FetchStoreOrdersDone
  | FetchAwaitingStoreOrderProposals
  | RemoveStoreOrders
  | FetchFilteredStores
  | FetchFilteredStoresDone
  | SaveFilteredStores
  | SaveFilteredStoresDone;
